export const saveFile = (content: ArrayBuffer, fileName: string) => {
  const element = document.createElement('a');
  element.setAttribute('download', fileName);
  const blob = new Blob([content]);
  const url = URL.createObjectURL(blob);
  element.setAttribute('href', url);
  element.click();
  URL.revokeObjectURL(url);
  element.remove();
};
